// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1Wgo0","log":"ModalInventoryLogs_log__3yi9h","date":"ModalInventoryLogs_date__2ShJq","userName":"ModalInventoryLogs_userName__1Oa66"};